<template>
	<!-- <footer
		class="mt-auto"
		:class="{
			bannerPadding: Capacitor.isNativePlatform(),
			'py-3': !Capacitor.isNativePlatform(),
		}">
		<div class="container text-center py-3">
			<router-link to="/terms" class="footer-link">Terms of Use</router-link>
			|
			<router-link to="/privacy-policy" class="footer-link"
				>Privacy Policy</router-link
			>
			<p class="mt-2">
				&copy; {{ new Date().getFullYear() }}
				<a href="https://digitalfuturelabs.com" class="footer-link"
					>Digital Future Labs.</a
				>
				All rights reserved.
			</p>
		</div>
	</footer> -->

	<!-- Footer -->
	<footer
		class="mt-auto"
		:class="{
			bannerPadding: Capacitor.isNativePlatform(),
		}">
		<div class="container">
			<div class="row g-4">
				<div class="col-md-3">
					<div class="mb-3">
						<a class="text-decoration-none fw-bold fs-4" href="#">
							<span class="text-success">Grub</span
							><span class="text-white">Vision</span>
						</a>
					</div>
					<p>
						Transforming how you understand your nutrition with cutting-edge AI
						technology.
					</p>
				</div>
				<!-- <div class="col-md-3">
					<h5 class="text-white mb-3">Features</h5>
					<ul class="list-unstyled">
						<li class="mb-2">
							<a href="#" class="text-white text-decoration-none"
								>Food Recognition</a
							>
						</li>
						<li class="mb-2">
							<a href="#" class="text-white text-decoration-none"
								>Nutritional Analytics</a
							>
						</li>
						<li class="mb-2">
							<a href="#" class="text-white text-decoration-none"
								>Health Reports</a
							>
						</li>
						<li class="mb-2">
							<a href="#" class="text-white text-decoration-none"
								>Meal Planning</a
							>
						</li>
					</ul>
				</div>
				<div class="col-md-3">
					<h5 class="text-white mb-3">Company</h5>
					<ul class="list-unstyled">
						<li class="mb-2">
							<a href="#" class="text-white text-decoration-none"
								>About Us</a
							>
						</li>
						<li class="mb-2">
							<a href="#" class="text-white text-decoration-none">Careers</a>
						</li>
						<li class="mb-2">
							<a href="#" class="text-white text-decoration-none">Blog</a>
						</li>
						<li class="mb-2">
							<a href="#" class="text-white text-decoration-none">Contact</a>
						</li>
					</ul>
				</div> -->
				<div class="col-md-3">
					<h5 class="text-white mb-3">Legal</h5>
					<ul class="list-unstyled">
						<li class="mb-2">
							<router-link
								to="/terms"
								class="footer-link text-white text-decoration-none"
								>Terms of Use</router-link
							>
						</li>
						<li class="mb-2">
							<router-link
								to="/privacy-policy"
								class="footer-link text-white text-decoration-none"
								>Privacy Policy</router-link
							>
						</li>
						<hr />
						<li class="mb-2">
							<router-link
								to="/pricing"
								class="footer-link text-white text-decoration-none"
								>Pricing & Plans</router-link
							>
						</li>
						<!-- <li class="mb-2">
							<a href="#" class="text-white text-decoration-none"
								>Cookie Policy</a
							>
						</li> -->
					</ul>
				</div>
			</div>
			<div class="border-top border-secondary mt-4 pt-4 text-center">
				<p>
					&copy; {{ new Date().getFullYear() }}
					<a href="https://digitalfuturelabs.com" class="footer-link"
						>Digital Future Labs</a
					>. All rights reserved.
				</p>
			</div>
		</div>
	</footer>
</template>

<script setup>
	import { Capacitor } from "@capacitor/core"
</script>

<style lang="less" scoped>
	@import "../assets/colors.less";

	footer {
		background-color: rgba(4, 17, 15, 0.8);
		border-top: 1px solid rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(8px);
		-webkit-backdrop-filter: blur(8px);
		padding: 2.5rem 0; // equivalent to py-10
		color: #ffffff;
		font-weight: bold;
	}

	footer a {
		// color: @color3;
		margin: 0 5px;
		text-decoration: none;
	}

	footer a:hover {
		text-decoration: underline;
	}

	.bannerPadding {
		padding: 10px 0 70px 0;
	}
</style>
